import request from '@/api/request'

// ========== 用户信息相关 ==========

// 获取用户信息
export const getUserInfo = () => request.get('/api/user/info')

// 更新用户基本信息（username, gender, phone, tags, signature）
export const updateUserInfo = (data) => request.post('/api/update/info', data)

// 更新头像和背景图（avatar和backgroundImage为base64格式）
export const updateUserImage = (data) => request.post('/api/update/image', data)

// 修改密码
export const updatePassword = (data) => request.post('/api/update/password', data)

// 更新邮箱
export const updateEmail = (data) => request.post('/api/update/email', data)

// 更新手机号
export const updatePhone = (userId, phone) => request.post('/api/update/phone', null, { params: { userId, phone } })

// 更新QQ号
export const updateQqNum = (data) => request.post('/api/update/qq', data)

// 更新微信号
export const updateWechatNum = (data) => request.post('/api/update/wechat', data)

// 更新微博号
export const updateWeiboNum = (data) => request.post('/api/update/weibo', data)

// 实名认证
export const updateRealNameAuth = (data) => request.post('/api/update/realname', data)

// ========== 主题/背景设置（合并） ==========
// GET /api/user/theme/get?userId=xxx - 返回 {userId, themeMode, themeColor, wallpaperUrl, wallpaperType}
// POST /api/user/theme/update (body: {userId, themeMode, themeColor, wallpaperUrl, wallpaperType})
export const getThemeSetting = (userId) => request.get('/api/user/theme/get', { params: { userId } })
export const updateThemeSetting = (data) => request.post('/api/user/theme/update', data)

// 背景设置也用同一个API（后端没有独立的背景设置表）
export const getBackgroundSetting = (userId) => request.get('/api/user/theme/get', { params: { userId } })
export const updateBackgroundSetting = (data) => request.post('/api/user/theme/update', data)

// ========== 隐私设置 ==========
// GET /api/user/privacy/get?userId=xxx
// POST /api/user/privacy/update?userId=xxx&friendVisible=xxx&phoneVisible=xxx&signatureVisible=xxx&dynamicPermission=xxx
export const getPrivacySetting = (userId) => request.get('/api/user/privacy/get', { params: { userId } })
export const updatePrivacySetting = (params) => request.post('/api/user/privacy/update', null, { params })

// ========== 通用设置 ==========
// GET /api/user/general/get?userId=xxx
// POST /api/user/general/update (body: {userId, fontSize, language, autoClearCache})
export const getGeneralSetting = (userId) => request.get('/api/user/general/get', { params: { userId } })
export const updateGeneralSetting = (data) => request.post('/api/user/general/update', data)
export const clearCache = (userId) => request.post('/api/user/general/clear-cache', null, { params: { userId } })

// ========== 通知设置 ==========
// GET /api/user/notice/get?userId=xxx
// POST /api/user/notice/update (body: {userId, newMessage, comment, like, system, sound, vibrate})
export const getNoticeSetting = (userId) => request.get('/api/user/notice/get', { params: { userId } })
export const updateNoticeSetting = (data) => request.post('/api/user/notice/update', data)

// ========== 上传相关 ==========
export const uploadAvatar = (formData) => request.post('/api/upload/avatar', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
})

export const uploadBackground = (formData) => request.post('/api/upload/background', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
})
